module.exports = __webpack_public_path__ + "img/device_c4_one_en.091a7898.png";